import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setDisplayName,
} from 'recompose';

import { injectIntl, LightButton, Tooltip } from 'components';
import { STRIPE } from 'constants/options';
import { payOnlineHelper } from 'constants/strings';

const PayoutsButton = (
  { formatMessage },
  { accessToken, currentUser, payOnline },
) => (
  <a
    href={payOnline ? (currentUser.account.connectedAccount
      ? `${process.env.API_BASE_URL}/payment/transfers?accessToken=${accessToken}`
      : `https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=${STRIPE.connect.clientId.test}&scope=read_write&state=${accessToken}&redirect_uri=${process.env.API_BASE_URL}/oauth/stripe`
    ) : '#'}
    style={{ textDecoration: 'none' }}
    className={payOnline ? '' : 'read-only'}
    onClick={(e) => { if (!payOnline) e.preventDefault(); }}
  >
    <Tooltip tooltip={payOnline ? '' : formatMessage(payOnlineHelper)}>
      <LightButton>
        {currentUser.account.connectedAccount ? formatMessage('View Transfers To Bank') : formatMessage('Add Payouts')}
      </LightButton>
    </Tooltip>
  </a>
);

PayoutsButton.contextTypes = {
  accessToken: PropTypes.string,
  currentUser: PropTypes.shape({}),
  payOnline: PropTypes.bool,
};

PayoutsButton.propTypes = {
  formatMessage: PropTypes.func.isRequired,
};

export default compose(
  setDisplayName('PayoutsButton'),
  injectIntl,
)(PayoutsButton);
